export default __webpack_public_path__ + "static/brand-logo-ego-25dce22fb17770e7474da30778842c95.png";